import { useCallback } from "react";
import { useSDK } from "@contentful/react-apps-toolkit";
import { GlossaryId, GlossaryLocalePair, Locale } from "../lib";
import { getPlanFromCredentials } from "../utils";

interface PutDictionaryRequestBody {
    source_lang: Locale;
    target_lang: Locale;
    entries: string;
    entries_format: "csv";
}

export const usePutDeeplDictionary = () => {
    const sdk = useSDK();
    const deeplCredentials = sdk.parameters.installation.deeplApiKey;

    const putDeeplDictionary = useCallback(
        async (
            glossaryId: GlossaryId,
            localePair: GlossaryLocalePair,
            entries: string
        ): Promise<void> => {
            if (!deeplCredentials) {
                throw new Error("Missing DeepL credentials");
            }

            const plan = getPlanFromCredentials(deeplCredentials);
            const requestBody: PutDictionaryRequestBody = {
                source_lang: localePair.source,
                target_lang: localePair.target,
                entries,
                entries_format: "csv",
            };

            const response = await fetch(`/api/${plan}/v3/glossaries/${glossaryId}/dictionaries`, {
                method: "PUT",
                headers: {
                    Authorization: `DeepL-Auth-Key ${deeplCredentials}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) {
                throw new Error(`Error deleting DeepL dictionary. Status: ${response.status}`);
            }
        },
        [deeplCredentials]
    );
    return { putDeeplDictionary };
};
